import React from 'react';
import { motion, Variants, Transition } from 'framer-motion';
import { slideVariants, transitions } from './animationVariants';

export interface PageTransitionProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  variants?: Variants;
  transition?: Transition;
}

export const PageTransition: React.FC<PageTransitionProps> = ({
  children,
  className,
  style,
  variants = slideVariants,
  transition = transitions.fast,
}) => {
  return (
    <motion.div
      initial="initial"
      animate="in"
      exit="out"
      variants={variants}
      transition={transition}
      className={className}
      style={{ width: '100%', height: '100%', ...style }}
    >
      {children}
    </motion.div>
  );
};

export default PageTransition;
